import React from 'react';
import { Icon } from './Icon.js';
export const IconChartStackedArea = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M2 10V6H5L7 10H9L14.5 3H22V5", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M5 14H2V20H22V9H19L16.5 12H13.1429L10 16H6.5L5 14Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconChartStackedArea.js.map